<template>
    <div>
        <Backer v-if="showbacker != false"/>

        <div style="width: 90%; margin-left: 0; margin-right: auto;">
            <div style="font-size: 25px; display: inline-block; margin: 10px; font-weight: bold; text-align: left;">
                Requests
            </div>
            <div style="display: inline-block;" v-if="viewdata == undefined">
                <b-form-select 
                    style="width: 250px;"
                    v-on:change="fetchTrs"
                    v-model="status"
                >
                    <b-form-select-option v-for="status in global_vars.TRANSFER_STATUSES" :value="status.value" v-bind:key="value">{{status.text}}</b-form-select-option>
                    
                </b-form-select>
            </div>
        </div>

        <div class="">
            <b-overlay :show="trs_being_loaded" rounded="sm">
                <div>
                    <b-alert show variant="warning" v-if="transfer_requests.length <= 0">
                        No Items In this state
                    </b-alert>
                    <div v-else>

                        <!-- <b-card header="SOME SKU 12321122 "class="overflow-hidden" style="max-width: 100%;">

                            <b-row no-gutters>
                                <b-col md="3">
                                    <b-card-text>
                                        NEED ON: 2019-10-21
                                    </b-card-text>

                                    <b-card-text>
                                        REQUESTOR: LANCASTER
                                    </b-card-text>

                                    <b-card-text>
                                        <b-badge variant="success">INVOICE # 1122322</b-badge>
                                    </b-card-text>
                                </b-col>

                                <b-col>
                                    
                                        <b-table-simple hover small caption-top responsive style="font-size: 14px;">
                                            <b-thead style="background: #efefef; color: black;">
                                                <b-tr>
                                                    <b-th style="border: 1px solid gray;">PRD</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">RQ</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">AQ</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">PLD-Q</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">PCK-Q</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">DRP-Q</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">RSHP-Q</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">SHP-Q</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">DLV-Q</b-th>
                                                    <b-th colspan="1" style="border: 1px solid gray;">REC-Q</b-th>
                                                    <b-th style="border: 1px solid gray;">FULFILL</b-th>
                                                    <b-th style="border: 1px solid gray;">STATUS</b-th>

                                                </b-tr>
                                            </b-thead>

                                            <b-tbody>
                                                <b-tr>
                                                    <b-td style="border: 1px solid gray;">BARCELONA-RSF-CH</b-td>
                                                    <b-td style="border: 1px solid gray;">13</b-td>
                                                    <b-td style="border: 1px solid gray;"><b-input size="sm" style="width: 50px; margin: auto;"></b-input></b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">12</b-td>
                                                    <b-td style="border: 1px solid gray;">
                                                        <b-form-select 
                                                            style=""
                                                            v-on:change="fetchTrs"
                                                            v-model="status"
                                                        >
                                                            <b-form-select-option v-for="status in global_vars.TRANSFER_STATUSES" :value="status.value">{{status.text}}</b-form-select-option>
                                                                                                                        
                                                        </b-form-select>
                                                    </b-td>
                                                    <b-td style="border: 1px solid gray;">
                                                        <b-form-select 
                                                            style=""
                                                            v-on:change="fetchTrs"
                                                            v-model="status"
                                                        >
                                                            <b-form-select-option v-for="status in global_vars.TRANSFER_STATUSES" :value="status.value">{{status.text}}</b-form-select-option>
                                                                                                                        
                                                        </b-form-select>
                                                    </b-td>

                                                </b-tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    
    
                                </b-col>
                            </b-row>

                        </b-card> -->

                        <table style="width: 100%;">
                            <thead>
                                <tr style="background: #efefef;">
                                    <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                        REQ BY
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('request_date')">
                                        NEED ON
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('tr_date')">
                                        RQSTD ON
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('product_sku')">
                                        PRODUCT
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items requested.">
                                        RQ
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items approved.">
                                        AQ
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items pulled for shipping.">
                                        PQ
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items shipped.">
                                        SQ 
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items delivered.">
                                        DQ 
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items received in okay state.">
                                        RCOK
                                    </td>
                                    <td class="ipt_tdhr" v-b-tooltip.top title="# of items received in damaged state.">
                                        RCDMG
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                        TO
                                    </td>
                                    <td class="ipt_tdhr" v-on:click="sortby('source_location_id')">
                                        FRM
                                    </td>

                                    <td class="ipt_tdhr" v-on:click="sortby('status')">
                                        STATUS
                                    </td>
                                    <td class="ipt_tdhr">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="tritem, idx in transfer_requests" :style="{'background-color': (( isNaN(parseInt(tritem.received_quantity)) == false && tritem.approved_quantity  != tritem.received_quantity ) ? '#fff9c4':'inherit'), 'border': ((active == idx) ? '3px solid black' : 'inherit')}" v-if="showRow(idx)" v-bind:key="tr_id">
                                    <td class="ipt_tdr">
                                        {{ locationsdict[tritem.location_id] }}
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ tritem.request_date }}
                                    </td>

                                    <td class="ipt_tdr">
                                        {{ tritem.tr_date }}
                                    </td>

                                    <td class="ipt_tdr">
                                        <div style="font-weight: bold; padding: 3px;">{{ tritem.product_sku }}</div>
                                        <div>{{ tritem.vendor }} ( {{ tritem.category }} )</div>
                                        <b-badge variant="success" v-if="tritem.invoice_id">sale # {{ tritem.invoice_id}}</b-badge>
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;">
                                        <span v-if="tritem.status == 0">
                                            <input 
                                                style="width: 45px; text-align: center; background: aliceblue; font-size: 12px; margin: auto; font-weight: bold; border: 1px solid #737373; border-radius: 2px;" 
                                                v-model="transfer_requests[idx].requested_quantity" 
                                                size="sm"
                                                type="number"
                                                min="0"
                                                step="1"
                                            ></input>
                                        </span>
                                        <span v-else>
                                            {{ tritem.requested_quantity }}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;">
                                        <span v-if="userDetails.userrole == 'admin' & [0,1].indexOf(tritem.status) >= 0">
                                            <input 
                                                style="width: 45px; text-align: center; background: aliceblue; font-size: 12px; margin: auto; font-weight: bold; border: 1px solid #737373; border-radius: 2px;" 
                                                v-model="transfer_requests[idx].approved_quantity" 
                                                size="sm"
                                            ></input>
                                        </span>
                                        <span v-else>
                                            {{ tritem.approved_quantity }}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;">
                                        {{ tritem.pulled_quantity }}
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;" >
                                        {{ tritem.shipped_quantity }}
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;" >
                                        {{ tritem.delivered_quantity }}
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;">
                                        <span v-if="tritem.status == 5">
                                            <input 
                                                style="width: 45px; text-align: center; background: aliceblue; font-size: 12px; margin: auto; font-weight: bold; border: 1px solid #737373; border-radius: 2px;" 
                                                v-model="transfer_requests[idx].received_okay_quantity" 
                                                size="sm"
                                            ></input>
                                        </span>
                                        <span v-else>
                                            {{ tritem.received_okay_quantity }}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr" style="width: 45px;">
                                        <span v-if="tritem.status == 5">
                                            <input 
                                                style="width: 45px; text-align: center; background: aliceblue; font-size: 12px; margin: auto; font-weight: bold; border: 1px solid #737373; border-radius: 2px;" 
                                                v-model="transfer_requests[idx].received_damaged_quantity" 
                                                size="sm"
                                            ></input>
                                        </span>
                                        <span v-else>
                                            {{ tritem.received_damaged_quantity }}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr">
                                        <div>{{ locationsdict[transfer_requests[idx].location_id] }}</div> 
                                        <div>{{ sublocationsdict[transfer_requests[idx].sublocation_id] }}</div>
                                    </td>

                                    <td class="ipt_tdr" style="width: 200px;">
                                        <div v-if="userDetails.userrole == 'admin'">
                                            <div style="margin: 3px;">
                                                <b-form-select v-model="tritem.locsub">
                                                    <b-form-select-option v-for="locsub in locsubs" :value="locsub.value" :disabled="((locsub.location_id == tritem.location_id) ? true: false)" v-bind:key="location_id">
                                                        
                                                        {{ all_loc_inventory_dict[
                                                            JSON.stringify(tritem.product_id)
                                                            +
                                                            tritem.product_sku
                                                            +
                                                            JSON.stringify(locsub.location_id)
                                                            +
                                                            JSON.stringify(locsub.sublocation_id)
                                                        ]}} 

                                                        - 

                                                        {{ locsub.location }} | {{ locsub.sublocation }} 
                                                    </b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <span v-if="transfer_requests[idx].source_location_id">
                                                <div>
                                                    {{ locationsdict[transfer_requests[idx].source_location_id] }}
                                                </div> 
                                                <div>
                                                {{ sublocationsdict[transfer_requests[idx].source_sublocation_id] }}</div>
                                            </span>
                                        </div>

                                        <div v-if="transfer_requests[idx].pullist_name" style="padding: 2px; font-size: 10px; background: rgb(42, 132, 247); color: white; font-weight: bold;">
                                            <div>PL # {{ transfer_requests[idx].pullist_name }}</div>
                                        </div>
                                    </td>

                                    <td class="ipt_tdr" :style="{'background-color': tr_item_statuses_colors[tritem.status], 'width': '130px'}">
                                        <span v-if="userDetails.userrole == 'admin'">
                                            
                                            <b-form-select
                                                v-model="transfer_requests[idx].status"
                                                size="sm"
                                                :disabled="tritem.status >= 3"
                                            >
                                                <b-form-select-option v-for="status in global_vars.TRANSFER_STATUSES" :value="status.value" :disabled="status.value > 2 || status.value == null" v-bind:key="value">{{status.text}}</b-form-select-option>
                                            </b-form-select>
                                        </span>
                                        <span v-else>
                                            {{ tr_item_statuses_dict[tritem.status] }}
                                        </span>
                                    </td>

                                    <td class="ipt_tdr">
                                        <b-button size="sm" variant="danger" style="padding: 3px; margin: 1px; font-size: 12px; font-weight: bold;"  :disabled="is_action_disabled" @click="markTRItemReceived(idx)" v-if="tritem.status == 5">Mark Received</b-button>

                                        <span>
                                            <span v-if="userDetails.userrole == 'admin' && tritem.status < 3">
                                                <b-button size="sm" variant="success" style="padding: 3px; margin: 1px; font-size: 12px; font-weight: bold;" :disabled="is_action_disabled" @click="updateTRItem(idx)">Update</b-button>
                                            </span>
                                            <span v-else>
                                                <span v-if="tritem.status == 0">
                                                    <b-button size="sm" variant="success" style="padding: 3px; margin: 1px; font-size: 12px; font-weight: bold;" :disabled="is_action_disabled" @click="updateTRItem(idx)">Update</b-button>
                                                </span>
                                            </span>
                                        </span>

                                        <span>
                                            <span v-if="userDetails.userrole == 'admin'">
                                                <b-button size="sm" variant="dark" style="padding: 3px; margin: 1px; font-size: 12px; font-weight: bold;" @click="deleteTRItem(idx)" :disabled="is_action_disabled">Delete</b-button>
                                            </span>
                                            <span v-else>
                                                <span v-if="tritem.status == 0">
                                                    <b-button size="sm" variant="dark" style="padding: 3px; margin: 1px; font-size: 12px; font-weight: bold;" @click="deleteTRItem(idx)" :disabled="is_action_disabled">Delete</b-button>
                                                </span>
                                            </span>
                                        </span>

                                        <!-- <b-button size="sm" variant="outline-dark" style="padding: 1px; margin: 1px; font-size: 12px; font-weight: bold;" @click="getTRItemAvailability(idx)" :disabled="is_action_disabled" v-if="userDetails.userrole=='admin'">Check</b-button> -->

                                        <span v-if="tritem.product_id == -1">
                                            <span v-if="tritem.po_number != null">
                                                <b-button size="sm" style="padding: 1px; margin: 1px; font-size: 12px; font-weight: bold; background: #5dbefb;"  :disabled="is_action_disabled" @click="showAssociatedPurchaseOrder(idx)" v-if="userDetails.userrole == 'admin'">PO # {{ tritem.po_number }}</b-button>
                                            </span>
                                            <span v-else>
                                                <b-button size="sm" style="padding: 1px; margin: 1px; font-size: 12px; font-weight: bold; background: orange;"  :disabled="is_action_disabled" @click="triggerPurchaseOrderCreate(idx)" v-if="userDetails.userrole == 'admin' && [0,1,2].indexOf(status) >= 0">Create PO</b-button>
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </b-overlay>

            <b-modal id="modal-availability" scrollable title="" size="md" hide-footer>
                <Availability :viewdata="{availability_data:availability_data, product_id: q_product_id, product_sku: q_product_sku}" :locationsdict="locationsdict" :sublocationsdict="sublocationsdict" />
            </b-modal>

            <b-modal id="modal-purchase-order" scrollable title="" size="xl" hide-footer>
                <PurchaseOrder :viewdata="{po_number: selected_po_number}" />
            </b-modal>
        </div>

    </div>

</template>

<script>
    import global_vars from "@/utilities/global_vars"
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import Availability from '@/components/importables/Availability'
    import PurchaseOrder from "@/components/PurchaseOrder"

    export default {
        name: "MyRequests",
        props: ["showbacker", "viewdata"],
        components: {
            Backer, 
            Availability,
            PurchaseOrder,
        },
        data: function(){
            let out = {
                global_vars: global_vars,
                userDetails: {properties: {}},
                status: 1,
                request_types: [
                    {value: "transfer_for_display", text: "Store Transfer (for display)"},
                    {value: "transfer_for_pickup", text: "Store Transfer (for store pickup)"},
                    {value: "transfer_for_storage", text: "Store Transfer (for storage)"},
                    {value: "transfer_for_delivery", text: "Customer Transfer (for customer delivery)"}
                ],
                request_types_dict: {
                    transfer_for_display: {text: "Display", color: "green"},
                    transfer_for_storage: {text: "Storage", color: "cornflowerblue"},
                    transfer_for_delivery: {text: "Customer Delivery", color: "red"},
                    transfer_for_pickup: {text: "Store Pickup", color: "blue"}
                },
                locsubs: [],
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                tr_status: null,
                tr_item_statuses: global_vars.TRANSFER_STATUSES,
                tr_item_statuses_colors: global_vars.TRANSFER_STATUSES_COLORS_DICT,
                tr_item_statuses_dict: global_vars.TRANSFER_STATUSES_DICT,
                trs_being_loaded: true,
                transfer_requests:[],
                item_being_reserved: false,
                availables: {},
                numbers_being_fetched: false,
                display_tr_with_status: null,
                buffered: {},
                is_action_disabled: false,
                availability_data: [],
                q_product_id: null,
                q_product_sku: null,
                sort_asc: true,
                active: null,
                selected_po_number: null,
                all_loc_inventory_dict: {},
            };
            return out;
        },
        methods: {
            showRow: function(idx){
                let item = this.transfer_requests[idx];
                let status = this.status;
                if (status == null){
                    return true
                }
                else {
                    //pending
                    if (status == 0){
                        return true
                    }
                    //for approved
                    else if (status == 1){
                        return true
                    }
                    //rejected
                    else if (status == 2){
                        return true
                    }
                    //pulled
                    else if (status == 3){
                        return true
                    }
                    //shipped
                    else if (status == 4){
                        return true
                    }
                    //received
                    else if (status == 5){
                        return true
                    }
                    else if (status == 6){
                        return true
                    }
                }
            },
            isAdmin: function(){
                if (this.userDetails.userrole == 'admin'){
                    return true
                }
                else {
                    return false
                }
            },
            showAssociatedPurchaseOrder: function(idx){
                let item = this.transfer_requests[idx];
                let po_number = item.po_number;
                if (po_number){
                    this.selected_po_number = po_number;
                    this.$bvModal.show("modal-purchase-order");
                }
                else {
                    this.$bvToast.toast(
                        "PO Number not valid.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

            },
            triggerPurchaseOrderCreate: function(idx){
                let item = this.transfer_requests[idx];
                let that = this;
                let tr_id = item.tr_id;
                let itemid = item.itemid;
                let product_id = item.product_id;
                let product_sku = item.product_sku;
                let location_id = item.location_id;
                let sublocation_id = item.sublocation_id;
                let quantity = parseInt(item.approved_quantity);
                let invoice_id = item.invoice_id;
                //fix this crap
                let vendor = item.vendor;
                let category = item.category;

                if (isNaN(quantity)){
                    this.$bvToast.toast(
                        "Please make sure the approved quantity of items is there before creating a PO against the transfer request item.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                let data = {
                    tr_id: tr_id, 
                    itemid: itemid, 
                    product_id: product_id, 
                    product_sku: product_sku, 
                    quantity: quantity,
                    username: this.userDetails.username,
                    location_id: location_id,
                    sublocation_id: sublocation_id,
                    vendor: vendor,
                    category: category
                };

                let path = "/api/inventory/create_po_for_tr_item/"
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully created a PO against this item", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.transfer_requests[idx].po_number = response.data.result.po_number;
                        //that.transfer_requests[idx].status = 3
                    }
                    that.transfer_requests[idx].edit = false;
                    that.is_action_disabled = false;
                    that.buffered = {};
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred trying to create PO for this item.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.is_action_disabled = false;
                }

                this.is_action_disabled = true
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                                
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_locations_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locsubs = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading locations/sublocations.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.all_loc_inventory_dict = response.data.result;
                                //console.log(response.data.result)
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
                that.fetchTrs();
            },
            fetchTrs: function() {
                let that = this;
                let status = parseInt(this.status);

                if (isNaN(status)) {
                    status = null;
                }

                let path =  "/api/inventory/my_transfer_requests/";
                let data = {userid: this.userDetails.id,  status: status};
                if (this.viewdata) {
                    if (this.viewdata.discrepancies){
                        data.discrepancies = true;
                        //data.status = 6;
                        data.status = null
                    }
                }
                    
                let s = function(response){
                    if (response.data.result){
                       that.transfer_requests = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.trs_being_loaded = false;
                }
                
                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading transfer requests.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.trs_being_loaded = false;
                }
                
                this.trs_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f)
            },
            updateTRItem: function(idx) {
                let that = this;
                let item = this.transfer_requests[idx];

                let requested_quantity = item.requested_quantity;
                let approved_quantity = item.approved_quantity;
                let pulled_quantity = item.pulled_quantity;
                let shipped_quantity = item.shipped_quantity;
                let delivered_quantity = item.delivered_quantity;
                let received_okay_quantity = item.received_okay_quantity;
                let received_damaged_quantity = item.received_damaged_quantity;
                let source_location_id = item.source_location_id;
                let source_sublocation_id = item.source_sublocation_id;

                if (item.locsub) {
                    let splitted = item.locsub.split("|").map(function(d){ return +d });
                    if (splitted.length > 1){
                        item.source_location_id = splitted[0];
                        item.source_sublocation_id = splitted[1];

                        source_location_id = item.source_location_id;
                        source_sublocation_id = item.source_sublocation_id;
                    }
                }

                if (item.status == 1 && (item.source_location_id == null || item.source_location_id == undefined)){
                    this.$vex.dialog.alert({
                        message: "Please assign a `FRM` (or fulfilling) location for an approved item."
                    });
                    this.transfer_requests[idx].status = 0;
                    return
                }                


                if (requested_quantity != null && isNaN(parseInt(requested_quantity)) ) {
                    this.$vex.dialog.alert({
                        message: "Invalid requested quantity. Please specify a valid numeric value"
                    });
                    return
                }

                if (approved_quantity != null && isNaN(parseInt(approved_quantity)) ) {
                    this.$vex.dialog.alert({
                        message: "Invalid approved quantity. Please specify a valid numeric value"
                    });
                    return
                }
                
                if (received_okay_quantity != null && isNaN(parseInt(received_okay_quantity)) ) {
                    this.$vex.dialog.alert({
                        message: "Invalid received quantity. Please specify a valid numeric value"
                    });
                    return
                }

                if (received_damaged_quantity != null && isNaN(parseInt(received_damaged_quantity))) {
                    this.$vex.dialog.alert({
                        message: "Invalid damaged quantity. Please specify a valid numeric value"
                    });
                    return
                }

                if (( parseInt(received_okay_quantity) + parseInt(received_damaged_quantity) ) > parseInt(approved_quantity)){
                    this.$vex.dialog.alert({
                        message: "Cannot receive more than allotted or approved."
                    });
                    return
                }


                if (( parseInt(received_okay_quantity) && isNaN(parseInt(received_damaged_quantity))) ){
                    this.$vex.dialog.alert({
                        message: "Please indicate valid received / damaged quantities."
                    });
                    return
                }

                if (( parseInt(received_damaged_quantity) && isNaN(parseInt(received_okay_quantity))) ){
                    this.$vex.dialog.alert({
                        message: "Please indicate valid received / damaged quantities."
                    });
                    return
                }
                
                let path = "/api/inventory/update_tr_item/"
                let data = {
                    tr_id: item.tr_id,
                    itemid: item.itemid,
                    requested_quantity: (parseInt(requested_quantity) || null),
                    approved_quantity: (parseInt(approved_quantity) || null), 
                    pulled_quantity: (parseInt(pulled_quantity) || null),
                    shipped_quantity: (parseInt(shipped_quantity) || null),
                    delivered_quantity: (parseInt(delivered_quantity) || null),
                    received_okay_quantity: (parseInt(received_okay_quantity) || null),
                    received_damaged_quantity: (parseInt(received_damaged_quantity) || null),
                    source_location_id: source_location_id,
                    source_sublocation_id: source_sublocation_id,
                    status: item.status,
                };
                let s = function(response){
                    if (response.data.error){
                        that.$vex.dialog.alert({
                            message: response.data.error
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully updated item.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                        if (that.status == 0 && (item.status == 1 || item.status == 2)){
                            that.transfer_requests.splice(idx, 1);
                        }
                        else if (that.status == 1 && (item.status == 0 || item.status == 2)){
                            that.transfer_requests.splice(idx, 1);
                        }
                        else if (that.status == 2 && (item.status == 0 || item.status == 1) ){
                            that.transfer_requests.splice(idx, 1);
                        }
                        else {
                            that.transfer_requests = that.transfer_requests;
                        }
                    }
                    that.is_action_disabled = false;
                    that.buffered = {};
                }
                let f = function(error){
                    console.log(error);
                    that.$vex.dialog.alert({
                        message: "Error occurred trying to update the item."
                    });
                    that.is_action_disabled = false;
                }
                this.is_action_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);

            },
            deleteTRItem: function(idx){
                let that = this;
                function delete_tr_item(idx){
                    let item = that.transfer_requests[idx];
                    let tr_id = item.tr_id;
                    let itemid = item.itemid;
                    let pullist_name = (item.pullist_name || null)


                    let path = "/api/inventory/delete_tr_item/";
                    let data = {tr_id: tr_id, itemid: itemid};
                    if (pullist_name){
                        data.pullist_name = pullist_name;
                    }
                    let s = function(response){
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error, 
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                        }
                        else {
                            that.$bvToast.toast(
                                "Successfully deleted item from TR.", 
                                {title: "Success", autoHideDelay: 1500, variant:"dark"}
                            );
                            that.transfer_requests.splice(idx, 1);
                        }
                        that.is_action_disabled = false;
                    }
                    let f = function(error){
                        console.log(error);
                        that.$bvToast.toast(
                            "Error occurred trying to delete item from TR.", 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.is_action_disabled = false;
                    }
                    that.is_action_disabled = true;
                    Requestor.postAsyncP(path, data, this, s, f);
                }

                let message = "Are you absolutely sure you want to delete this transfer request item?"

                if (this.transfer_requests[idx].pullist_name){
                    message = "This item is part of the pullist ("+this.transfer_requests[idx].pullist_name+"). Deleting it will remove it from the pullist as well. Continue?"
                }
                this.$vex.dialog.confirm({
                    message: message,
                    callback: function (value) {
                        if (value){
                            delete_tr_item(idx);
                        }
                    }
                });                
            },
            markTRItemReceived: function(idx){
                let item = this.transfer_requests[idx];

                let that = this;
                let tr_id = item.tr_id;
                let itemid = item.itemid;
                
                let received_okay_quantity = item.received_okay_quantity;
                let received_damaged_quantity = item.received_damaged_quantity;
                let approved_quantity = item.approved_quantity;

                if (received_okay_quantity != null && isNaN(parseInt(received_okay_quantity)) ) {
                    this.$vex.dialog.alert({
                        message: "Invalid received quantity. Please specify a valid numeric value"
                    });
                    return
                }

                if (received_damaged_quantity != null && isNaN(parseInt(received_damaged_quantity))) {
                    this.$vex.dialog.alert({
                        message: "Invalid damaged quantity. Please specify a valid numeric value"
                    });
                    return
                }

                if (( parseInt(received_okay_quantity) + parseInt(received_damaged_quantity) ) > parseInt(approved_quantity)){
                    this.$vex.dialog.alert({
                        message: "Cannot receive more than allotted or approved."
                    });
                    return
                }

                if (( parseInt(received_okay_quantity) && isNaN(parseInt(received_damaged_quantity))) ){
                    this.$vex.dialog.alert({
                        message: "Please indicate valid received / damaged quantities."
                    });
                    return
                }

                if (( parseInt(received_damaged_quantity) && isNaN(parseInt(received_okay_quantity))) ){
                    this.$vex.dialog.alert({
                        message: "Please indicate valid received / damaged quantities."
                    });
                    return
                }
                
                let data = {
                    tr_id: tr_id, 
                    itemid: itemid, 
                    received_okay_quantity: parseInt(received_okay_quantity), 
                    received_damaged_quantity: parseInt(received_damaged_quantity),
                    received_by: this.userDetails.username,
                };
                let path = "/api/inventory/mark_tr_item_received/";
                let s = function(response) {
                    if (response.data.error) {
                        that.$vex.dialog.alert({
                            message: response.data.error
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            "Item successfuly marked as received.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.transfer_requests[idx].status = 6; 
                    }
                    that.is_action_disabled = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$vex.dialog.alert({
                        message:  "An error occurred trying to mark the item as received. Please try again."
                    });
                    that.is_action_disabled = false;
                }

                this.is_action_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            markTRItemComplete: function(idx){
                let that = this;
                let item = this.transfer_requests[idx];
                let tr_id = item.tr_id;
                let itemid = item.itemid;
                let path = "/api/inventory/mark_tr_item_complete_st_tran/";
                let data = {tr_id: tr_id, itemid: itemid};
                
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Item successfuly marked as received.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.transfer_requests[idx].status = 4; 
                    }
                    that.is_action_disabled = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "An error occurred trying to mark the item as received. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.is_action_disabled = false;
                }

                this.is_action_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },

            getTRItemAvailability: function(idx){
                this.active = idx;
                let path = "/api/inventory/get_tr_item_availability/";
                let item = this.transfer_requests[idx];
                let data = {product_id: item.product_id, product_sku: item.product_sku};
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.availability_data = response.data.result;
                        that.q_product_id = item.product_id;
                        that.q_product_sku = item.product_sku;
                        that.$bvModal.show("modal-availability");
                    }
                    that.is_action_disabled = false
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "An error occurred trying to fetch product availability. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.is_action_disabled = false
                }
                this.is_action_disabled = true;
                Requestor.getAsync(path, data, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.transfer_requests = Requestor.sort(this.transfer_requests, key)
                }
                else {
                    this.transfer_requests = Requestor.sort_reverse(this.transfer_requests, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();

            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14px;
        background: #e5ffb1;
    }

    td {
        padding: 3px;
        background: inherit;
        font-size: 14px;
    }

    select {
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/MyRequests.vue